import { createAsyncTypes } from 'utils/ActionCreator'

export const STATUS_365_REQUEST_ASYNC = createAsyncTypes(
  'STATUS_365_REQUEST_ASYNC',
  'Settings/EmailServer/O365'
)
export const DISABLE_365_INTEGRATION_REQUEST_ASYNC = createAsyncTypes(
  'DISABLE_365_INTEGRATION_REQUEST_ASYNC',
  'Settings/EmailServer/O365'
)

export const STATUS_POWERSHELL_REQUEST_ASYNC = createAsyncTypes(
  'STATUS_POWERSHELL_REQUEST_ASYNC',
  'Settings/EmailServer/Powershell'
)

export const DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC = createAsyncTypes(
  'DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC',
  'Settings/EmailServer/Powershell'
)

export const STATUS_LIST_OPTIONS = {
  DISABLED: 0,
  ENABLED: 1,
  ADVANCED: 2,
}
